<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="lg">
        <div class="container-fluid" v-if="photos" >
            <div v-for="(photo) in photos" v-bind:key="photo.id">
                <img :src="photo.url" width="720"/>
            </div>

        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    export default {
        name: "FitmentPhotosView",
        components: {
            'b-modal': bModal
        },
        data() {
            return {
                show: false,
                processing: false,
                photos: null
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.show = true;
                this.$eventBus.$emit('FitmentApiData');
            }
        },
        created() {
            this.$eventBus.$on('FitmentPhotosView', (data) => {
                if (data != null) {
                    this.photos = data.photos;
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>